/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import DS from 'ember-data';
import CustomerModel from 'cio/models/customer';
import ObjectModel from 'cio/models/object';

interface RecentActivityArgs {
  model: CustomerModel | ObjectModel;
  type: string;
}

export default class RecentActivity extends Component<RecentActivityArgs> {
  @service store!: DS.Store;

  fetchLogs = task({ drop: true }, async () => {
    let query = { type: `${this.args.type}_change` };

    return this.args.model.queryLogs(query);
  });
}
